import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useState } from "react";
import {
    Table,
    Text,
    Breadcrumb,
    Tabs
} from "@artprov/design-system";
import { columnasAutorizaciones } from '../columnasAutorizaciones';

const emptyState = {
    icon: 'info',
    title: 'Sin solicitudes',
    description: 'Actualmente, no tenés solicitudes que requieran tu aprobación. Volvé a revisar más tarde.',
    descriptionStyles: 'description-emptystate-autorizaciones',
    iconStyles: 'text-warning-10',
    titleStyles: 'text-primary-10',
};

export default function Contenido({ data, tabSelected, setTabSelected }) {
    const { id } = useParams();
    const isNumberOne = id === '1';
    const location = useLocation()
    const navigate = useNavigate()
    const solicitudes = isNumberOne ? [] : data;
    const [selectedRow, setSelectedRow] = useState([]);


    return (
        <div className={`container mx-auto flex flex-col h-full  min-h-[800px] items-center my-8 px-2 xl:px-8`}>
            <div className="w-full flex flex-col justify-center gap-y-1 p-2">
                <Breadcrumb
                    customItems={getBreadCrumbs()}
                    onClick={(href) => {
                        if (href) navigate(href);
                    }}
                />
            </div>
            <div className="w-full flex flex-col justify-between p-1">
                <Text variant="h6" className="text-primary-10">Revisión de solicitudes Pendientes</Text>
                <Text variant="body2 text-tertiary-0" >Aca podés revisar, aprobar o rechazar las solicitudes que requieren tu autorización.</Text>
            </div>
            <div className="w-full flex justify-between border-b border-primary-10 my-4">
                <div className="flex">
                    <Tabs
                        className="w-[284px]"
                        classNameTabButton="h-[32px]"
                        underline={false}
                        items={[
                            { text: "Pendientes", id: "pendientes" },
                            { text: "Historial", id: "historial" }
                        ]}
                        selected={tabSelected}
                        setSelected={setTabSelected}
                    />
                </div>
            </div>
            <div className="w-full min-h-[300px] flex flex-col gap-y-2 my-2">
                <Table
                    data={solicitudes}
                    selectable={false}
                    columns={columnasAutorizaciones}
                    emptyState={emptyState}
                    selected={selectedRow}
                />
            </div>
        </div>
    )
}

function getBreadCrumbs() {
    return [
        { label: "Inicio", href: "/", disabled: false },
        { label: "Autorizaciones", disabled: true }
    ];
}